import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
// @ts-ignore
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CredentialsService} from '../@shared/services/credentials.service';
import {CacheService} from '../@shared/services/cache.service';

/**
 * Add httpheader with to all API calls
 */
@Injectable({
    providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
    constructor(private credentialService: CredentialsService, private router: Router, private cacheService: CacheService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // if (apisWithoutAuthToken.indexOf(request.url) > -1) {
        //     return next.handle(request);
        // }

        // No API call can be made without the token - if the user is logged in then JWT token
        // or else the Basic Auth.
        // The API calls can be made by authorized clients only which is determined
        // by the JWT / Basic token

        if (this.credentialService.credentials) {
            const accessToken = this.credentialService.credentials.accessToken;
            const selectedCompanies = this.cacheService.retrieveStringifyResponse('selected-companies');
            const selectedRoles = this.cacheService.retrieveStringifyResponse('selected-role');
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`,
                    'selected-tw-companies': selectedCompanies?.toString()?.length > 0 ? selectedCompanies : '',
                    'selected-shipping-roles': selectedRoles?.toString()?.length > 0 ? selectedRoles : '',
                },
            });
        } else {
            request = request.clone({
                setHeaders: {
                    Authorization: `Basic ` + btoa(environment.clientIdAndSecret),
                },
            });
        }

        return next.handle(request);
    }
}

